import { Box, BoxProps } from '@mui/material';
import React, { FC } from 'react';

const ContainerBox: FC<BoxProps> = ({ sx, ...props }) => (
    <Box
        {...props}
        sx={[
            {
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                px: 2,
                pb: 6,
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ]}
    />
);

export default ContainerBox;
